import React from 'react';

import { useAppSelector } from 'flow/hooks/useRedux';
import { selectHasTicketsSetAccessLevel } from 'flow/selectors/feature-flag-selectors';
import { TicketKey } from 'flow/types/EntityKeys';
import TicketAccessField from './TicketAccessField';
import TicketMembersInfoItem from './TicketMembersInfoItem';

interface Props {
    ticketKey: TicketKey;
}

/** Which of the two access controls a viewer gets, and nothing else. */
const TicketAccessSection = ({ ticketKey }: Props) => {
    const hasTicketsSetAccessLevel = useAppSelector(
        selectHasTicketsSetAccessLevel,
    );

    if (!hasTicketsSetAccessLevel) {
        return <TicketMembersInfoItem ticketKey={ticketKey} />;
    }

    return <TicketAccessField ticketKey={ticketKey} />;
};

export default React.memo(TicketAccessSection);
